import React from 'react';

interface ProductImageProps {
  imageFolder: string;
  refNumber: string;
  altText: string;
}

export const ProductImage: React.FC<ProductImageProps> = ({ imageFolder, refNumber, altText }) => (
  <img
    alt={altText}
    src={`/${imageFolder}/${refNumber}.png`}
    style={{ width: "100%" }}
  />
);